import { Injectable } from "@angular/core";

@Injectable({
	providedIn: "root"
})
export class Base64Service {
	encode(data: string): string {
		return btoa(unescape(encodeURIComponent(data)));
	}

	decode(encStr: string): string {
		return atob(decodeURIComponent(escape(encStr)));
	}

	encodeJson(json: any): string {
		return this.encode(JSON.stringify(json));
	}

	decodeJson<T>(encStr: any): T {
		return <T>JSON.parse(this.decode(encStr));
	}
}
